import {FixtureDefinition} from './fixtures.types';

/** Each fixture type owns its lazy generator. Add types here without changing the global dialog. */
export const FIXTURE_DEFINITIONS: readonly FixtureDefinition[] = [
  {
    id: 'early-bid',
    label: 'Early Bid',
    description: 'Nová testovací aukce, testovací účty a scénáře limitace, licitace a výherců.',
    loadComponent: () => import('./early-bid/early-bid-fixtures.component').then(module => module.EarlyBidFixturesComponent),
  },
];
